package com.fireavert.fire_risk.data_models

enum class RiskLevel(val number: Int, val color: String) {
    ONE(number = 1, color = "#FEDEAB"),
    TWO(number = 2, color = "#FCCEA1"),
    THREE(number = 3, color = "#F9BD97"),
    FOUR(number = 4, color = "#F7AD8D"),
    FIVE(number = 5, color = "#F59D83"),
    SIX(number = 6, color = "#F28C78"),
    SEVEN(number = 7, color = "#F07C6E"),
    EIGHT(number = 8, color = "#EE6C64"),
    NINE(number = 9, color = "#EB5B5A"),
    TEN(number = 10, color = "#E94B50"),
//    UNKNOWN(number = 0, color = "#D9D9D9")
    ;

    val description: String
        get() = when (number) {
            in 1..3 -> "Low Risk"
            in 4..6 -> "Medium Risk" // You can change this to "Moderate Risk" if preferred
            in 7..8 -> "High Risk"
            in 9..10 -> "Very High Risk"
            else -> "Not yet calculated" // Should not happen with current enum values
        }

    companion object {
        fun fromNumber(number: Int): RiskLevel? {
            return entries.find { it.number == number }
        }
    }
}

